// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 65 ? "initial" : chunkId) + "." + {"65":"b61fb12b","807":"1b7b6ed7"}[chunkId] + ".chunk.css";
};